<script>
    import Carousel from '@beyonk/svelte-carousel'
    import { ChevronLeftIcon, ChevronRightIcon } from 'svelte-feather-icons'
    import { Link } from "svelte-routing";
    import { getAllWorks, worksStore } from '../../scripts/works'
    import Source from '../common/PictureSource.svelte';

    async function works() {
        if($worksStore.length == 0){
            await getAllWorks().then(r => $worksStore = r)
        }
        return $worksStore
    }
</script>
<style>
  section{
    margin: 1em 0;
  }
  .control :global(svg) {
		width: 100%;
		height: 100%;
		color: #fff;
		border: 2px solid #fff;
		border-radius: 32px;
	}
  .control{
    cursor: pointer;
  }
  .slide-content{
    text-align: end;
  }
  .title-container{
    display: inline-block;
    border-right: solid grey 5px;
    background-color: white;
    padding-right: 5%;
    max-width: 80%;
  }
  .placeholder{
    background: radial-gradient(circle, rgb(74 74 74 / 64%) 10%, #272727);
  }
  :global(button){
    padding: .4rem;
  }
</style>
<section class="hero">
{#await works()}
  <div class="slide-content placeholder"></div>
{:then works}
  <Carousel perPage={{1200: 3, 800: 2}}>
    <span class="control" slot="left-control">
      <ChevronLeftIcon />
    </span>
    {#each works as work, i}
    
      <div class="slide-content item-{i + 1}" >
        <picture>
          <Source media="(max-width: 600px)" fit="fill" width=600 height=555 image = {work.images[0].url} /> 
          <Source media="(min-width: 601px)" fit="fill" width=800 height=740 image = {work.images[0].url} /> 
          <Source media="(min-width: 800px)" fit="fill" width=600 height=555 image = {work.images[0].url} /> 
          <Source media="(min-width: 1800px)" fit="fill" width=800 height=740 image = {work.images[0].url} /> 
          <img class="featured" src="{work.images[0].url}?fit=fill&fill=blur&w=500&h=525&fm=jpg" alt={work.title + " - " + work.survey.subAtomicDate}>
        </picture>
        <Link to={ "/product/" + work.id }> 
          <div class="title-container">
            <p class="title">
              {work.title}
            </p>
            <p class="subtitle">
              {work.survey.subAtomicDate}
            </p>
          </div>
        </Link>
      </div>

    {/each}
    <span class="control" slot="right-control">
      <ChevronRightIcon />
    </span>
  </Carousel> 

{/await}
</section>
